import React, {useEffect, useRef, useState} from 'react';
import {Box} from '../box';
import {VisibilityBox} from '../box/visibility-box';
import {Button} from '../button/button';
import {HorizontalDivider} from '../divider';
import {GridBox} from '../grid-box';
import {theme} from '../theme/theme';
import {Typography} from '../typography';

export interface ColumnTextProps {
  column1Text?: string | null;
  column2Text?: string | null;
}

export const ColumnText: React.FC<ColumnTextProps> = ({
  column1Text,
  column2Text,
}: ColumnTextProps) => {
  const [isViewingMore, setIsViewingMore] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const overflowSpaceRef = useRef<HTMLDivElement | null>(null);

  const handlePressViewMore = () => {
    setIsViewingMore(true);
  };

  useEffect(() => {
    const el = overflowSpaceRef.current;
    if (el !== null) {
      if (el.offsetHeight < el.scrollHeight) {
        setIsOverflowing(true);
      }
    }
  }, []);

  return (
    <Box
      paddingX="lg"
      paddingY="seven"
      maxHeight={isViewingMore ? undefined : '522px'}
      overflow="hidden"
      ref={overflowSpaceRef as any}
    >
      <GridBox
        columns={[1, 2]}
        space="eight"
        css={{border: 'none'}}
        backgroundColor="surfaceDark"
      >
        <Typography color="textDefault">{column1Text}</Typography>
        <Typography color="textDefault">{column2Text}</Typography>
      </GridBox>
      <VisibilityBox show={[true, false]}>
        {/* @ts-expect-error condition fix */}
        {!isViewingMore && isOverflowing && (
          <Box
            position="absolute"
            bottom="0"
            left="0"
            right="0"
            zIndex="1"
            backgroundColor="surfaceDark"
          >
            <Box
              position="absolute"
              left="0"
              right="0"
              bottom="0"
              height="130px"
              css={{
                background: theme.colors.gradientViewMore,
              }}
            />
            <HorizontalDivider />
            <Button type="secondary" onPress={handlePressViewMore}>
              View more
            </Button>
            <HorizontalDivider />
          </Box>
        )}
      </VisibilityBox>
    </Box>
  );
};
